import type { BleedLabelSpec } from '../helpers/bleed-label-layout'

/** One warning label over the print-bleed tint ring, positioned by `computeBleedLabelLayout`. */
export function BleedBandLabel({ wrap, style, copy }: Omit<BleedLabelSpec, 'key'>) {
  return (
    <div
      className={`doc-band__label pointer-events-none absolute text-center ${wrap === 'nowrap' ? 'whitespace-nowrap' : 'whitespace-normal'} text-[color:var(--doc-label)]`}
      style={style}
      aria-hidden
    >
      {copy}
    </div>
  )
}
